import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MomentModule } from 'angular2-moment';
import { NgSlimScrollModule } from "../../../node_modules/ngx-slimscroll/src/ngx-slimscroll/module/ngx-slimscroll.module";
import { BusyModule } from 'angular2-busy';

import { BrightServeModule } from "app/brightserve/brightserve.module";

import { AddonService } from './addon.service';

import { ATMISTFormComponent } from './ATMIST/atmist-form.component';
import { AddonAllergyComponent } from './allergy/addon-allergy.component';
import { AddonMedicationComponent } from './medication/addon-medication.component';
import { AddonMedicalHistoryComponent } from './medical-history/addon-medical-history.component';
import { AddonIncidentDetailsComponent } from './incident-details/addon-incident-details.component';
import { AddonIncidentFindingsComponent } from './incident-findings/addon-incident-findings.component';
import { AddonIncidentAdviceComponent } from './incident-advice/addon-incident-advice.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ModalModule,
        MomentModule,
        NgSlimScrollModule,
        BusyModule,
        BrightServeModule
    ],
    declarations: [ATMISTFormComponent, AddonAllergyComponent, AddonMedicationComponent, AddonMedicalHistoryComponent, AddonIncidentDetailsComponent, AddonIncidentFindingsComponent, AddonIncidentAdviceComponent],
    exports: [ATMISTFormComponent, AddonAllergyComponent, AddonMedicationComponent, AddonMedicalHistoryComponent, AddonIncidentDetailsComponent, AddonIncidentFindingsComponent, AddonIncidentAdviceComponent],
    providers: [AddonService]
})
export class AddonModule { }



// WEBPACK FOOTER //
// ./src/app/add-ons/addon.module.ts